import $ from 'jquery';

export default class specialOffer {
    constructor() {
        //Switch between forms
        $('.secspecialoffer__choice').on('click', function () {
            $('.secspecialoffer__choice').removeClass('secspecialoffer__choice-chosen');
            $(this).toggleClass('secspecialoffer__choice-chosen');
            var activeFormIndex = $(this).attr('id').replace(/secspecialoffer__choice-/, '');
            $('.secspecialoffer__wrapper-form').removeClass('secspecialoffer__form-active');
            $('#secspecialoffer__form-'+activeFormIndex).toggleClass('secspecialoffer__form-active');
        });
        //Childinfo handlers
        var childinfoCount = 1;
        
        //Reveal another childinfo field on addchild
        $('.secspecialoffer__form-addchild').on('click', function () {
            $('.secspecialoffer__form-childinfo:hidden:first').toggle();
        });
        
        //On removechild, hide the childinfo field, clean hidden input fields
        $('div.secspecialoffer__form-removechild').on('click', function () {
            $(this).parent().toggle();
            $(this).parent().find('input').val('');
            $(this).parent().find('select').val('');
        });
        
        
        /*Add childinfo field on addchild, give fields unique ids 
        $('.secspecialoffer__form-addchild').on('click', function () {
            var cellHTML = $('.secspecialoffer__form-childinfo').first().html();
            childinfoCount += 1;
            $('.secspecialoffer__form-wrapperchildren').append('<div class="secspecialoffer__form-childinfo">'+cellHTML+'</div>')
            $('.secspecialoffer__form-childinfo').last().find('.secspecialoffer__form-row span input[name="data-urodzenia"]').attr('id','data-urodzenia_'+childinfoCount);
            $('.secspecialoffer__form-childinfo').last().find('.secspecialoffer__form-row span select[name="placowka-select"]').attr('id','placowka-select_'+childinfoCount);
            $('.secspecialoffer__form-childinfo').last().find('.secspecialoffer__form-row span select[name="sport"]').attr('id','sport_'+childinfoCount);
            $('.secspecialoffer__form-childinfo').last().find('.secspecialoffer__form-row span select[name="sposob"]').attr('id','sposob_'+childinfoCount);
        });
        */
        
        /*Remove childinfo using event delegation, decrease id count - not used in the newest implementatnion
        $('#childinfo').on('click', 'div.secspecialoffer__form-removechild', function () {
            $(this).parent().remove();
            childinfoCount -= 1;
        });
        */
        
        
    }
}
